<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="currentItem['name'+_lang]" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">

        <div class="mydialog df-l-c-fs" slot="content">
          <div class="scroll-box w100p">
            <div class="f-s stickybox _bf overview">{{combo_allItems}}</div>
            
            <div class="combo-item w100p" v-for="(x1,i1) in currentItem.setMenuOneItemList" :key="i1">

              <!-- 选择菜 先显示分类名称 -->
              <div class="text40 f-gray df-c-sb sls" v-if="!x1.fixed">
                <span class="f-s sls">{{(x1['catalog'+_lang])+' '+(x1.index||'')}}</span>
                <span :class="{'_redcolor':x1.checkedNum<x1.minNumber}">{{x1.menuLimitText}}</span>
              </div>

              <div class="combo-item-conntent" :class="{
                'ml20':!x1.fixed,
                'combo-item-conntent-warning':x1.showWarning,
                '_be':x2.saleOut||x1.checkedNum===x1.maxNumber,
              }" v-for="(x2,i2) in x1.itemList" :key="i2">
                <!-- 固定菜 -->
                <div class="f-gray df-c-sb f-s" v-if="x1.fixed">
                  <div class="text40">{{x2['name'+_lang]+' '+(x2.index||'')}}</div>
                  <!-- <div class="combo-item-price text40" :class="{'_cc':x2.saleOut}">{{x2.setMenuAddPrice|toprice(2)}}</div> -->
                </div>
                <!-- 选择菜 -->
                <div class="f-gray df mtb10 plr10 br12" v-else>
                  <!-- 左边勾选+名称 -->
                  <div class="df-c-fs f1" @click="dialogCombo_selectFood(x1,x2,i2)">
                    <div class="imgbox mr20 ptb10">
                      <img style="width:20px;height:20px;" mode="aspectFill" :src="(x2.select?iconCheckok2:iconChecknull2)" />
                    </div>
                    <div class="text40 f-s" :class="{'_cc':x2.saleOut}">{{x2['name'+_lang]+' '+(x2.index||'')}}</div>
                  </div>
                  <!-- 右边计数器+价格 -->
                  <div class="df-c-ct" v-if="!x2.copy&&x2.select">
                    <img class="item-btn"
                      :src="iconSubtract1"
                      :class="{'img-to-gray':x2.checkedNum<=1}"
                      @click.prevent.stop="dialogCombo_subtract(x1,x2,i2)">
                    <div class="item-number">{{x2.checkedNum}}</div>
                    <img class="item-btn"
                      :src="iconAdd1"
                      :class="{'img-to-gray':x1.checkedNum>=x1.maxNumber}"
                      @click.prevent.stop="dialogCombo_add(x1,x2,i2)">
                  </div>
                  <div class="combo-item-price text40" :class="{'_cc':x2.saleOut}" v-if="!currentItem.realPriceItem">{{x2.setMenuAddPrice|toprice(2,true)}}</div>
                </div>

                <!-- 菜品规格 -->
                <div class="spec-box mb20 pl40" v-for="(x3,i3) in x2.itemDetailList" :key="i3" v-show="x1.fixed||(!x1.fixed&&x2.opened)">
                  <div class="text40 f-gray df-c-sb sls">
                    <span class="f-s sls">{{x3['name'+_lang]}}</span>
                    <span :class="{'_redcolor':x3.checkedNum<x3.minSelect}">{{x3.specLimitText}}</span>
                  </div>
                  <div class="spec-content df-w-fs">
                    <div
                      v-for="(x4,i4) in x3.nameAndPriceList" :key="i4"
                      class="spec-item df" @click="dialogCombo_selectSpec(x1,x2,x3,x4,i2)"
                      :class="{
                        '_bf':x2.select&&(x3.checkedNum<x3.maxSelect||!x3.multi),
                        'spec-item-warning':x3.showWarning,
                        '_be':x3.multi&&x3.checkedNum&&x3.checkedNum===x3.maxSelect,
                      }">
                      <div class="imgbox mr20 ptb10">
                        <img
                          style="width:20px;height:20px;" mode="aspectFill"
                          :src="x3.multi
                            ?(x4.select?iconCheckok:iconChecknull)
                            :(x4.select?iconCheckok2:iconChecknull2)" />
                      </div>
                      <div class="text40 f-s f-gray f1">{{x4['name'+_lang]}}</div>
                      <div class="text40 f-s f-red ml10" v-if="!currentItem.realPriceItem">{{x4.price|toprice(2,true)}}</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <div class="btm w100p df-fe-sb">
            <!-- 下左 -->
            <div class="left">
              <div class="item w100p df-fs ai-fs">
                <span class="lable f-xxs df-c-ct">{{$t('menu.selectSpec')}}：</span>
                <span class="f1">{{combo_specItems}}</span>
              </div>
              <div class="item f-xxxs w100p f-silvery">{{combo_priceItems}}</div>
            </div>
            <!-- 下右 -->
            <div class="right sls">
              <div class="price-box sls df-c-fe f1">
                <span class="f-s">{{$t('common.total')}}：</span>
                <span class="f-xl _redcolor sls" v-if="currentItem.realPriceItem">{{$t('menu.timePrice')}}</span>
                <span class="f-xl _redcolor sls" v-else>{{combo_totalPrice|toprice(2)}}</span>
                <!-- <span class="f-xl _redcolor sls">{{combo_totalPrice|toprice(2)}}</span> -->
              </div>
              <div class="df-c-fe">
                <div :class="{'themebtn':submitBtnOk,'whitebtn':!submitBtnOk,'themebtn-en':lang==='en'}" @click="dialogSubmit(true)" class="mr10" v-if="showRefreshAndSend">{{$t('menu.refreshAndSend')}}</div>
                <div :class="submitBtnOk?'themebtn':'whitebtn'" @click="dialogSubmit(false)" v-if="showRefresh">{{$t('menu.refresh')}}</div>
                <div :class="submitBtnOk?'themebtn':'whitebtn'" @click="dialogSubmit(false)" v-if="openFrom==='menu'">{{$t('menu.add')}}</div>
              </div>
            </div>
          </div>
        </div>
          
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogCombo',
  data() {
    return {
      isShowDialog: false,
      
      currentItem: '',
      currentItem_copy: '',

      combo_allItems: '', // 对话框 上方 总计
      combo_specItems: '', // 对话框 左下角 已选择菜品
      combo_priceItems: '', // 对话框 左下角 已选择菜品+价格
      combo_totalPrice: '', // 对话框 左下角 总计

      submitBtnOk: false,
      openFrom: '', // cart购物车 menu菜单
    }
  },
  computed: {
    showRefreshAndSend() {
      const BEFORE = JSON.parse(JSON.stringify(this.currentItem_copy))
      BEFORE.setMenuOneItemList && BEFORE.setMenuOneItemList.length && BEFORE.setMenuOneItemList[0].itemList.forEach(x1 => {
        delete x1.index
        delete x1.checkedNum
      })
      const NOW = JSON.parse(JSON.stringify(this.currentItem))
      NOW.setMenuOneItemList && NOW.setMenuOneItemList.length && NOW.setMenuOneItemList[0].itemList.forEach(x1 => {
        delete x1.index
        delete x1.checkedNum
      })
      let result = this.openFrom === 'cart'
        && this.isHasSendCookId
        && this.user_x.privilegeList.includes('sjzhgl_bdcfxgcp')
        && JSON.stringify(BEFORE) !== JSON.stringify(NOW)
      // console.log(
      //   1111,
      //   this.openFrom,
      //   this.isHasSendCookId,
      //   this.user_x.privilegeList.includes('sjzhgl_bdcfxgcp'),
      //   JSON.stringify(BEFORE),
      //   JSON.stringify(NOW),
      //   result
      // )
      return result
    },
    showRefresh() {
      const BEFORE = JSON.parse(JSON.stringify(this.currentItem_copy))
      BEFORE.setMenuOneItemList && BEFORE.setMenuOneItemList.length && BEFORE.setMenuOneItemList[0].itemList.forEach(x1 => {
        delete x1.index
        delete x1.checkedNum
      })
      const NOW = JSON.parse(JSON.stringify(this.currentItem))
      NOW.setMenuOneItemList && NOW.setMenuOneItemList.length && NOW.setMenuOneItemList[0].itemList.forEach(x1 => {
        delete x1.index
        delete x1.checkedNum
      })
      let result = this.openFrom === 'cart'
        && JSON.stringify(BEFORE) !== JSON.stringify(NOW)
      // console.log(
      //   1111,
      //   this.openFrom,
      //   JSON.stringify(BEFORE),
      //   JSON.stringify(NOW),
      //   result
      // )
      return result
    },
  },
  methods: {
    open() {
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.currentItem = ''
      this.currentItem_copy = ''
      this.combo_allItems = '' // 对话框 上方 总计
      this.combo_specItems = '' // 对话框 左下角 已选择菜品
      this.combo_priceItems = '' // 对话框 左下角 已选择菜品+价格
      this.combo_totalPrice = '' // 对话框 左下角 总计
      this.submitBtnOk = false
      this.openFrom = ''
    },


    // 文本处理
    dialogCombo_textHandle() {
      const RESULT = { val0: '', val1: '', val2: '', val3: 0 }
      RESULT.val3 = this.currentItem.price
      
      if (this.currentItem) {
        let ids_val0 = []
        this.currentItem.setMenuOneItemList.forEach(x1 => {
          // #region 套餐对话框 上方 总计
          if (!ids_val0.includes(x1.id)) {
            //RESULT.val0 += (x1.fixed ? x1.itemList[0]['name' + this._lang] : x1.catalog)
            RESULT.val0 += (x1.fixed ? x1.itemList[0]['name' + this._lang] : x1['catalog' + this._lang])
            // RESULT.val0 += '*' + x1.itemNumber
            // RESULT.val0 += '*' + this.tothousands(x1.itemNumber)
            if (x1.fixed) {
              RESULT.val0 += '*' + this.tothousands(x1.itemNumber)
            } else {
              RESULT.val0 += x1.minNumber === x1.maxNumber
                ? `*${this.tothousands(x1.minNumber)}`
                : `*(${this.tothousands(x1.minNumber)}-${this.tothousands(x1.maxNumber)})`
            }
            !x1.fixed && (RESULT.val0 += `(${this.$t('food.choice')})`)
            RESULT.val0 += ' + '
            ids_val0.push(x1.id)
          }
          // #endregion
          
          x1.itemList.forEach(x2 => {
            if (x1.fixed || x2.select) { // 筛选不加配
              const FLAG = (x2.itemDetailList && x2.itemDetailList.length) || x2.checkedNum === 1 || x1.fixed
              // this.repeatFunction(x2, RESULT)
              let priceAll = Number(x2.setMenuAddPrice)
              RESULT.val1 += x2['name' + this._lang]
              RESULT.val2 += x2['name' + this._lang]
              // RESULT.val3 += Number(x2.setMenuAddPrice)
              RESULT.val3 += FLAG
                ? Number(x2.setMenuAddPrice)
                : Number(x2.setMenuAddPrice) * x2.checkedNum

              if (x2.itemDetailList && x2.itemDetailList.length) {
                RESULT.val1 += '('
                x2.itemDetailList.forEach(x3 => {
                  x3.nameAndPriceList.forEach(x4 => {
                    if (x4.select) {
                      RESULT.val1 += x4['name' + this._lang] + '、'
                      priceAll += Number(x4.price)
                      RESULT.val3 += Number(x4.price)
                    }
                  })
                })
                if (RESULT.val1[RESULT.val1.length - 1] === '(') {
                  RESULT.val1 = RESULT.val1.substr(0, RESULT.val1.length - 1)
                } else if (RESULT.val1[RESULT.val1.length - 1] === '、') {
                  RESULT.val1 = RESULT.val1.substr(0, RESULT.val1.length - 1)
                  RESULT.val1 += ')'
                }
              }
              RESULT.val1 += FLAG
                ? `、`
                : `*${x2.checkedNum}、`
              this.currentItem.realPriceItem ? RESULT.val2 += '、' : RESULT.val2 += FLAG
                ? `(${this.priceFormat(priceAll)})、`
                : `*${x2.checkedNum}(${this.priceFormat(priceAll * x2.checkedNum)})、`
              // console.log(`%cRESULT:`, 'color: #00f;', RESULT)
            }
          })
        })
        // #region 套餐对话框 上方 总计
        RESULT.val0 = RESULT.val0.substr(0, RESULT.val0.length - 3)
        // #endregion
        // #region 套餐对话框 左下角 已选择菜品
        if (RESULT.val1[RESULT.val1.length - 1] === '、') {
          RESULT.val1 = RESULT.val1.substr(0, RESULT.val1.length - 1)
        }
        // #endregion
        // #region 套餐对话框 左下角 已选择菜品+价格
        if (RESULT.val2[RESULT.val2.length - 1] === '、') {
          RESULT.val2 = RESULT.val2.substr(0, RESULT.val2.length - 1)
        }
        // #endregion
      }
      this.combo_allItems =  RESULT.val0
      this.combo_specItems = RESULT.val1
      this.combo_priceItems = RESULT.val2
      this.combo_totalPrice = RESULT.val3

      this.dialogCombo_btnOkFunction_select()
    },
    // 按钮禁用处理
    dialogCombo_btnOkFunction_select() {
      let flag0 = true
      this.currentItem.setMenuOneItemList.forEach(x1 => {
        if (!x1.fixed) {
          // 任意菜品
          let { minNumber, maxNumber, checkedNum, showWarning } = x1
          let flag1 = checkedNum < minNumber || checkedNum > maxNumber
          showWarning && this.$set(x1, 'showWarning', flag1)
          flag1 && (flag0 = false)
        }
        x1.itemList.forEach(x2 => {
          if (x1.fixed || (x2.select && Number(x2.id) !== 0)) { // 筛选不加配
            x2.itemDetailList.forEach(x3 => {
              let { required, checkedNum, minSelect, showWarning } = x3
              let flag2 = required && checkedNum < minSelect
              showWarning && this.$set(x3, 'showWarning', flag2)
              flag2 && (flag0 = false)
            })
          } else if (x2.id) {
            x2.itemDetailList.forEach(x3 => {
              this.$set(x3, 'showWarning', false)
            })
          }
        })
      })
      // console.log(`%cflag0:`, 'color: #00f;', flag0)
      this.submitBtnOk = flag0
    },
    dialogCombo_btnOkFunction_submit() {
      let flag0 = true
      this.currentItem.setMenuOneItemList.forEach(x1 => {
        if (!x1.fixed) {
          // 任意菜品
          let { minNumber, maxNumber, checkedNum } = x1
          let flag1 = checkedNum < minNumber || checkedNum > maxNumber
          this.$set(x1, 'showWarning', flag1)
          flag1 && (flag0 = false)
        }

        x1.itemList.forEach(x2 => {
          if (x1.fixed || (x2.select && Number(x2.id) !== 0)) { // 筛选不加配
            x2.itemDetailList.forEach(x3 => {
              let { required, checkedNum, minSelect } = x3
              let flag2 = required && checkedNum < minSelect
              this.$set(x3, 'showWarning', flag2)
              flag2 && (flag0 = false)
            })
          } else if (x2.id) {
            x2.itemDetailList.forEach(x3 => {
              this.$set(x3, 'showWarning', false)
            })
          }
        })
      })
      // console.log(`%cflag:`, 'color: #00f;', flag0)
      this.submitBtnOk = flag0
    },

    // 选择菜品
    dialogCombo_selectFood(item1, item2, index2) {
      // console.log(item1.itemList.map(x=>x.id), item2.id)
      // console.log(`%cresult:`, 'color: #f0f;', item1, item2)
      // console.log(`%citem1.checkedNum:`, 'color: #f0f;', item1.checkedNum)
      // console.log(`%citem2.checkedNum:`, 'color: #f0f;', item2.checkedNum)
      if (!item2.copy && !item1.fixed) {
        // 点击到了原菜的菜名
        // console.log(`%cflag:`, 'color: #00f;', !item2.copy && !item1.fixed)
        if (item2.select) {
          // 已经被勾选
          item2.select = false
          item2.opened = false
          // item1.checkedNum--
          item1.checkedNum -= item2.checkedNum
          item2.itemDetailList && item2.itemDetailList.forEach(x3 => {
            x3.checkedNum = 0
            x3.showWarning = false
            x3.nameAndPriceList.forEach(x4 => {
              x4.select = false
            })
          })
          // console.log(`%citem2.origin:`, 'color: #f0f;', item2.origin)
          if (item2.origin) {
            // 是原菜
            item2.index = ''
            item2.checkedNum = 0
            for (let i = 0; i < item1.itemList.length; i++) {
              const x = item1.itemList[i]
              if (x.id === item2.id && x.copy) {
                item1.itemList.splice(i, 1)
                // item1.checkedNum--
                i--
              }
            }
          }
        } else if (!item2.saleOut) {
          // 未售罄
          if (item1.checkedNum < item1.maxNumber) {
            item2.select = true
            item2.opened = true
            item1.checkedNum++
            if (item2.origin) {
              item2.checkedNum = 1
            }
          }
        }
        this.dialogCombo_textHandle()
      } else if (index2) {
        // 点击到了克隆菜的菜名
        // console.log(`%cflag:`, 'color: #00f;', index2)
        const ITEM = item1.itemList.find(x2 => x2.id === item2.id)
        ITEM.checkedNum--
        item1.checkedNum--
        item1.itemList.splice(index2, 1)
        this.dialogCombo_index(item1, item2)
        // this.dialogCombo_textHandle()
      }
    },
    // 选择规格
    dialogCombo_selectSpec(item1, item2, item3, item4) {
      if (item4.select) {
        item4.select = false
        item3.checkedNum--
      } else {
        if (item3.multi) {
          const MAX = item3.maxSelect
          const LIST_CHECKED = item3.nameAndPriceList.filter(x => x.select)
          if (LIST_CHECKED.length < MAX) {
            item4.select = true
            item3.checkedNum++
            !item2.select && this.dialogCombo_selectFood(item1, item2)
          } else {
            console.log(`%c已经达到上限了:`, 'color: #00f;')
          }
        } else {
          item3.nameAndPriceList.forEach(x => { x.select = false })
          item4.select = true
          item3.checkedNum = 1
          !item2.select && this.dialogCombo_selectFood(item1, item2)
        }
      }
      // 这里实际是重复调用
      this.dialogCombo_textHandle()
    },

    dialogCombo_subtract(item1, item2, index2) {
      if (item2.checkedNum > 1) {
        if (item2.itemDetailList && item2.itemDetailList.length) {
          let index = index2
          for (let i = index2; i < item1.itemList.length; i++) {
            const x = item1.itemList[i]
            if (x.id === item2.id) {
              index = i
            }
          }
          if (index !== index2) {
            item1.itemList.splice(index, 1)
            item1.checkedNum--
            item2.checkedNum--
            this.dialogCombo_index(item1, item2)
          } else {
            this.dialogCombo_selectFood(item1, item2)
          }
        } else {
          item1.checkedNum--
          item2.checkedNum--
          this.dialogCombo_index(item1, item2)
        }
      } else {
        this.dialogCombo_selectFood(item1, item2)
      }
    },
    dialogCombo_add(item1, item2, index2) {
      if (item1.checkedNum < item1.maxNumber) {
        if (item2.itemDetailList && item2.itemDetailList.length) {
          const NEWITEM = JSON.parse(JSON.stringify(item2))
          NEWITEM.copy = true
          NEWITEM.itemDetailList.forEach(x3 => {
            x3.checkedNum = 0
            x3.nameAndPriceList.forEach(x4 => {
              x4.select = false
            })
          })

          let index = index2
          for (let i = index2; i < item1.itemList.length; i++) {
            const x = item1.itemList[i]
            if (x.id === item2.id) {
              index = i
            }
          }
          item1.itemList.splice(index + 1, 0 ,NEWITEM)
        }
        item1.checkedNum++
        item2.checkedNum++
        this.dialogCombo_index(item1, item2)
      }
    },
    dialogCombo_index(item1, item2) {
      const ARR = item1.itemList.filter(x2 => x2.id === item2.id)
      if (ARR.length === 1) {
        ARR[0].index = ''
      } else {
        ARR.forEach((x1, i1) => {
          x1.index = i1 + 1
        })
      }
      this.dialogCombo_textHandle()
    },

    dialogSubmit(flag) {
      console.log(`%c当前弹框套餐:`, 'color: #00f;', this.currentItem, this.currentItem.setMenuOneItemList)

      this.dialogCombo_btnOkFunction_submit()

      if (this.submitBtnOk) {
        this.currentItem._price = this.combo_totalPrice
        this.$emit('submit', this.currentItem, flag)
      } else {
        this.$message.warning(this.$t('menu.addItemWarning'))
      }
    },
    
    // 父组件点击了套餐，打开对话框
    tapCombo(item) {
      this.openFrom = 'menu'
      this.isHasSendCookId = false
      this.comboHandle(item.setMenuOneItemList)
      this.currentItem = JSON.parse(JSON.stringify(item))
      console.log(`%c是套餐-商品詳情:`, 'color: #f00;', this.currentItem, this.currentItem.setMenuOneItemList)
      this.dialogCombo_textHandle()
      this.currentItem_copy = JSON.parse(JSON.stringify(item))
      this.open()
    },
    // 请求回来的菜品处理套餐列表
    comboHandle(combo) {
      for (let i1 = 0; i1 < combo.length; i1++) {
        const x1 = combo[i1]
        // console.log(`%ci1, x1:`, 'color: #00f;', i1, x1)
        
        x1.checkedNum = 0
        x1.showWarning = false

        x1.menuLimitText = x1.minNumber === x1.maxNumber
          ? this.$t('menu.specLimit2') + `${this.tothousands(x1.minNumber)}`
          : this.$t('menu.specLimit2') + `${this.tothousands(x1.minNumber)}-${this.tothousands(x1.maxNumber)}`

        x1.itemList.forEach(x2 => {
          x2.checkedNum = 0
          x2.opened = false
          x2.select = false
          x2.itemDetailList && x2.itemDetailList.forEach(x3 => {
            x3.checkedNum = 0
            x3.showWarning = false
            x3.nameAndPriceList && x3.nameAndPriceList.forEach(x4 => {
              x4.select = false
            })
            
            // #region 处理规格提示
            let specLimitText = ''
            if (x3.required || x3.minSelect > 0) {
              if (x3.minSelect === x3.maxSelect) {
                specLimitText = this.$t('menu.specLimit1') + this.tothousands(x3.minSelect)
              } else {
                specLimitText = this.$t('menu.specLimit3') + this.tothousands(x3.minSelect) + '-' + this.tothousands(x3.maxSelect)
              }
            } else {
              if (x3.minSelect === x3.maxSelect) {
                specLimitText = this.$t('menu.specLimit2') + this.tothousands(x3.minSelect)
              } else {
                specLimitText = this.$t('menu.specLimit2') + this.tothousands(x3.minSelect) + '-' + this.tothousands(x3.maxSelect)
              }
            }
            x3.specLimitText = specLimitText
            // #endregion
          })
        })

        if (x1.fixed) { // 固定菜 份数 > 1，需要展开
          if (x1.itemNumber > 1 && x1.itemNumber > x1.itemList.length) {
            x1.itemList[0].index = 1
            for (let i = 1; i < x1.itemNumber; i++) {
              let newOne = JSON.parse(JSON.stringify(x1.itemList[0]))
              newOne.index = i + 1
              x1.itemList.push(newOne)
            }
          }
        } else { // 不加配
          if (x1.addAdditional && x1.itemList[x1.itemList.length - 1].id) {
            x1.itemList.push({id:0,name_en:'No selection',name_zh:'不加配',select:false,checkedNum:0,setMenuAddPrice:x1.addPrice})
          }
          x1.itemList.forEach(x2 => {
            x2.origin = true
          })
        }
      }
      return combo
    },

    // 修改购物车里的套餐
    comboCartModify(cartItem, newItem, isHasSendCookId) {
      this.openFrom = 'cart'
      this.isHasSendCookId = !!isHasSendCookId
      this.comboHandle(newItem.setMenuOneItemList)
      console.log(`%c购物车的套餐:`, 'color: #00f;', cartItem, cartItem.setMenuOneItemList)
      console.log(`%c菜单的套餐:`, 'color: #00f;', newItem, newItem.setMenuOneItemList)

      cartItem.setMenuOneItemList.forEach((x1, i1) => {
        // console.log(`%c${i1}:`, 'color: #00f;', x1, newItem.setMenuOneItemList[i1])
        if (x1.fixed) {
          // console.log(`%cx1.id:`, 'color: #00f;', x1.id)
          const Y1 = newItem.setMenuOneItemList.find(x => x.id === x1.id && !x.done)
          if (Y1) {
            Y1.done = true
            x1.itemList.forEach(x2 => {
              // console.log(`%cx2.id:`, 'color: #00f;', x2.id)
              const Y2 = Y1.itemList.find(x => x.id === x2.id && !x.done)
              if (Y2) {
                Y2.uuidInOrderSetMenuItem = x2.uuidInOrderSetMenuItem
                Y2.done = true
                x2.itemDetailList.forEach(x3 => {
                  // console.log(`%cx3.id:`, 'color: #00f;', x3.id)
                  const Y3 = Y2.itemDetailList.find(x => x.id === x3.id && !x.done)
                  if (Y3) {
                    Y3.done = true
                    // Y3.checkedNum = x3.nameAndPriceList.length
                    const IDS = Y3.nameAndPriceList.map(x => x.id)
                    const LIST = x3.nameAndPriceList.filter(x => IDS.includes(x.id))
                    Y3.checkedNum = LIST.length

                    x3.nameAndPriceList.forEach(x4 => {
                      // console.log(`%cx4.id:`, 'color: #00f;', x4.id)
                      const Y4 = Y3.nameAndPriceList.find(x => x.id === x4.id && !x.done)
                      if (Y4) {
                        Y4.done = true
                        Y4.select = true
                      }
                    })
                  }
                })
              }
            })
          }
        } else {
          const Y1 = newItem.setMenuOneItemList.find(x => x.id === x1.id)
          if (Y1) {
            Y1.showWarning = false
            x1.itemList && x1.itemList.forEach(x2 => {
              const Y2 = Y1.itemList.find(x => x.id === x2.id && !x.copy)
              const Y2_INDEX = Y1.itemList.findIndex(x => x.id === x2.id && !x.copy)
              if (Y2 && Y2_INDEX >= 0) {
                Y2.uuidInOrderSetMenuItem = x2.uuidInOrderSetMenuItem
                Y2.select = true
                Y2.opened = true
                if (Y2.itemDetailList && Y2.itemDetailList.length) { // 有规格
                  // console.log(222, Y1.itemList)
    
                  let spec = null
    
                  Y1.checkedNum++
                  Y2.checkedNum++
                  if (Y2.edited) {
                    const Y2_ = JSON.parse(JSON.stringify(Y2))
                    spec = Y2_
                    Y2_.copy = true
                    Y2_.index = Y1.checkedNum
                    Y2_.checkedNum = 1
                    Y1.itemList.splice(Y2_INDEX + Y1.checkedNum - 1, 0, Y2_)
                  } else {
                    spec = Y2
                    Y2.index = 1
                    Y2.edited = true
                  }
                  
                  // #region 处理规格
                  spec.itemDetailList.forEach(Y3 => {
                    Y3.checkedNum = 0
                    Y3.nameAndPriceList.forEach(x4 => {
                      x4.select = false
                    })
                  })
    
                  x2.itemDetailList.forEach(x3 => {
                    const Y3 = spec.itemDetailList.find(x => x.id === x3.id)
                    if (Y3) {
                      // Y3.checkedNum = x3.nameAndPriceList.length
                      const IDS = Y3.nameAndPriceList.map(x => x.id)
                      const LIST = x3.nameAndPriceList.filter(x => IDS.includes(x.id))
                      Y3.checkedNum = LIST.length

                      Y3.showWarning = false

                      x3.nameAndPriceList.forEach(x4 => {
                        const Y4 = Y3.nameAndPriceList.find(x => x.id === x4.id)
                        if (Y4) {
                          // console.log(111, Y4.name, spec.index)
                          Y4.select = true
                        }
                      })
                    }
                  })
                  // #endregion
    
                } else { // 无规格
                  Y1.checkedNum += x2.countInOrder
                  Y2.checkedNum = x2.countInOrder
                }
              }
            })
          }
        }
      })
      this.currentItem = newItem
      this.dialogCombo_textHandle()
      this.currentItem_copy = JSON.parse(JSON.stringify(newItem))
      this.open()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px;
  .stickybox{position: sticky;top: 0;}
  .overview{border-bottom: 1px solid #EFEFEF;min-height: 28px;line-height: 28px;padding-bottom: 10px;z-index: 10;}

  .scroll-box{
    height: 380px;overflow: hidden scroll;
    .combo-item{
      .combo-food{
        height: 40px;line-height: 40px;padding: 0 10px;margin: 4px 0;border-radius: 10px;
      }
      &-conntent{
        border-radius: 10px;
        &-warning{background: #FFEFEE;}
      }
      &-price{min-width: 100px;text-align: right;padding-left: 20px;}
      .spec-box{
        padding: 5px 20px;min-height: 28px;line-height: 28px;
        .spec-content{
          .spec-item{
            max-width: 100%;margin: 4px 0 4px 20px;padding: 0 10px;border-radius: 10px;
            &-warning{background: #FFEFEE;}
          }
        }
      }

      .text40{min-height: 20px;line-height: 20px;padding: 10px 0;}
      .item-btn{width: 24px;height: 24px;border-radius: 50%;}
      .item-number{padding: 0 8px;}
    }
  }
  .btm{
    min-height: 80px;padding: 20px 0 10px;
    .left{
      max-width: 40%;
      .item{min-height: 24px;line-height: 24px;}
    }
    .right{
      max-width: 60%;
      .price-box{height: 48px;line-height: 48px;text-align: right;}
      .themebtn-en{font-size: 12px;}
    }
  }
}
</style>